import type { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Stack, tokens } from '@hotjar/hotsauce';

const Wrapper = styled(Stack)`
  min-width: 200px;
  height: auto;
  line-height: 10px;
  margin: 0 auto;
  position: relative;
  text-align: center;
`;

const FillerElement = styled.div`
  height: ${tokens.spacer.x5};
  width: 100%;
  background: ${tokens.color.neutral_200};
  border-radius: ${tokens.spacer.x0pt5};
`;

const Viewport = styled.div``;

interface EmbedPreviewFrameProps {
  children: ReactElement[];
}

export const EmbedPreviewFrame = ({ children }: EmbedPreviewFrameProps): JSX.Element => {
  return (
    <Wrapper spacing="x2" direction="column">
      <FillerElement />
      <FillerElement />
      <FillerElement />
      <Viewport>{children}</Viewport>
      <FillerElement />
      <FillerElement />
      <FillerElement />
    </Wrapper>
  );
};
